import NextImage from 'next/image';
import { useTranslations } from 'next-intl';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './ChargerFeaturesSection.module.css';

const FEATURE_ICONS = [
  getCompressedAssetUrl('/web_v2/site-static/ring-pro/icons/icon-3.svg'),
  getCompressedAssetUrl('/web_v2/site-static/ring-pro/icons/icon-wave.svg'),
  getCompressedAssetUrl('/web_v2/site-static/ring-pro/icons/icon-wireless.svg'),
  getCompressedAssetUrl('/web_v2/site-static/ring-pro/icons/icon-1.svg'),
  getCompressedAssetUrl('/web_v2/site-static/ring-pro/icons/icon-4.svg'),
  getCompressedAssetUrl('/web_v2/site-static/ring-pro/icons/icon-2.svg'),
];

const FEATURE_KEYS = [
  'universalCase',
  'embeddedSpeaker',
  'findMyCase',
  'smartLighting',
  'wirelessCharge',
  'otherFunctions',
];

/* ── Component ─────────────────────────────────────────── */

const ChargerFeaturesSection = () => {
  const t = useTranslations('ring-pro');

  return (
    <section className={styles.section}>
      <div className={styles.featuresGrid}>
        {FEATURE_KEYS.map((key, i) => (
          <div className={styles.featureCard} key={key}>
            <NextImage
              className={styles.featureIcon}
              src={FEATURE_ICONS[i]}
              alt=""
              width={36}
              height={36}
            />
            <p className={styles.featureTitle}>{t(`ring-pro.chargerFeatures.${key}.title`)}</p>
            <p className={styles.featureDesc}>{t(`ring-pro.chargerFeatures.${key}.description`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ChargerFeaturesSection;
